import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.project');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-project',
template: templateSource || '',
    styles: [`

/* file: /opt/season-cloud-manager/project/main/build/src/app/page.project/view.scss */
/* src/app/page.project/view.scss: no such file or directory */`],
})
export class PageProjectComponent implements OnInit {

    public loading: boolean = false;
    public list: any = [];
    public categories: string[] = [];
    public owners: any[] = [];
    public selectedCategory: string = "";
    public selectedOwner: string = "";

    public keyuptime: any = 0;

    public search: any = {
        text: "",
        page: 1,
        dump: 40
    }

    public pagination: any = {
        end: -1,
        start: -1,
        current: 0
    }

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        await this.service.auth.allow("/access");
        await this.loadCategories();
        await this.loadOwners();
        await this.load();
    }

    public async loadCategories() {
        const { code, data } = await wiz.call("categories");
        if (code == 200) {
            this.categories = data;
        }
    }

    public async loadOwners() {
        const { code, data } = await wiz.call("owners");
        if (code == 200) {
            this.owners = data;
        }
    }

    public async onCategoryChange(value: string) {
        this.selectedCategory = value;
        await this.load();
    }

    public async onOwnerChange(value: string) {
        this.selectedOwner = value;
        await this.load();
    }

    public async selectCategory(value: string) {
        await this.onCategoryChange(value);
    }

    public async selectOwner(value: string) {
        await this.onOwnerChange(value);
    }

    public selectedOwnerName() {
        if (!this.selectedOwner) return "";
        const o = this.owners.find(x => x.id === this.selectedOwner);
        return o ? o.name : this.selectedOwner;
    }

    public async load(page: number = 1) {
        if (this.loading) return;
        this.loading = true;
        this.pagination.current = page;
        this.search.page = page;
        this.list = [];
        await this.service.render();

        const { code, data } = await wiz.call("search", {
            ...this.search,
            category: this.selectedCategory,
            owner: this.selectedOwner
        });

        if (code == 200) {
            let { rows, lastpage } = data;
            const startpage = Math.floor((page - 1) / 10) * 10 + 1;
            this.list = rows;
            this.pagination.start = startpage;
            this.pagination.end = lastpage;
        }

        this.loading = false;
        await this.service.render();
    }

    public async searchAction() {
        let keyuptime: any = new Date().getTime();
        this.keyuptime = keyuptime;
        await this.service.render(500);
        if (this.keyuptime != keyuptime) return;
        await this.load();
    }

    public async toggleFavorite(event: MouseEvent, item: any) {
        event.stopPropagation();
        event.preventDefault();
        if (item.item_type !== 'project') return;
        const { code, data } = await wiz.call("toggle_favorite", { project_id: item.id });
        if (code == 200) {
            item.is_favorite = data.is_favorite;
            await this.service.render();
        }
    }

    public openItem(item: any) {
        if (item.item_type === 'group') {
            this.service.href(`/project-group/${item.id}/projects`);
            return;
        }
        this.service.href(`/project/${item.id}/info`);
    }

}

export default PageProjectComponent;